import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M72.532,8.609H11.839c-2.232,0-4.058,2.435-4.058,5.411V119.5H76.59V14.02C76.59,11.044,74.764,8.609,72.532,8.609z M21.566,67.569c-2.562,0-4.638-2.076-4.638-4.637c0-2.561,2.076-4.637,4.638-4.637s4.637,2.076,4.637,4.637C26.203,65.492,24.128,67.569,21.566,67.569z M78.452,0H5.918C2.654,0,0,3.061,0,6.824V119.5h2.137V6.824c0-2.584,1.694-4.687,3.781-4.687h72.534c2.087,0,3.781,2.104,3.781,4.687V119.5h2.137V6.824C84.371,3.061,81.716,0,78.452,0z`;

export const aciSeparateBredroom: SvgIconDefinition = {
  iconName: 'separate-bredroom',
  iconData: [height, width, path],
};
